import i18n from '#helpers/i18n/i18n.js'
import importTranslationFile from '#helpers/i18n/importTranslationFile.js'
import Logger from '#helpers/logging/Logger.js'
import { supportedLanguages } from '#src/constants/supportedLanguages.js'
import dayjs from 'dayjs'

/**
 * @param {string} locale - The locale to set in the system
 * @returns {Promise<void>}
 */
export default async function setI18nLanguage(locale) {
	Logger.debug('setI18nLanguage', locale)
	// don't do anything when the language is not supported
	if (!supportedLanguages.includes(locale)) {
		return
	}

	// if the language is not yet loaded in,
	if (!i18n.global.availableLocales.includes(locale)) {
		// async load it
		const messages = await importTranslationFile(locale)
		Logger.debug(`#src/translations/${locale}.json loaded`)
		// add it to the available locales
		i18n.global.setLocaleMessage(locale, messages.default)
	}

	// set i18n locale
	i18n.global.locale.value = locale
	// set localstorage locale
	localStorage.language = locale
	// set dayjs locale
	dayjs.locale(locale)
	// set dom locale
	document.querySelector('html').setAttribute('lang', locale)
}
